module.exports = __webpack_public_path__ + "img/competition_font.6eecb330.png";